import React, { useEffect, useRef, createElement } from 'react';
export function CaseStudyVideo() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Add Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/ffr68lte98.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(playerScript);
    document.head.appendChild(embedScript);
    // Clean up
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
      if (document.head.contains(embedScript)) {
        document.head.removeChild(embedScript);
      }
    };
  }, []);
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-181" data-mp="2oha7hhlej899">
      <div className="text-center mb-6" data-id="element-182" data-mp="2oibg7fey3int">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-183" data-mp="2offldzye9a3l">
          $200,000 en 30 Días
        </h2>
        <p className="text-xl text-gray-600" data-id="element-184" data-mp="agzrudfbbqyz">Caso de Estudio Real</p>
      </div>
      <div ref={containerRef} className="relative w-full aspect-video overflow-hidden" data-id="element-185" data-mp="aews31ocyjh2">
        <style data-id="element-186" data-mp="3soyzjzs2nfu6">
          {`
            wistia-player[media-id='ffr68lte98']:not(:defined) { 
              background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ffr68lte98/swatch'); 
              display: block; 
              filter: blur(5px); 
              padding-top: 56.25%; 
            }
          `}
        </style>
        <wistia-player media-id="ffr68lte98" aspect="1.7777777777777777" autoplay="false" data-id="element-187" data-mp="fh5k9vtephi4"></wistia-player>
      </div>
    </div>;
}